import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IframFormModalComponent } from '../ifram-form-modal/ifram-form-modal.component';

@Component({
	selector      : 'app-dynamicform',
	templateUrl   : './dynamicform.component.html',
	encapsulation : ViewEncapsulation.None,
})

export class DynamicformComponent implements OnInit {
	@Input() dFormContent : any;

	constructor(
		private modalService: NgbModal,
	) {}

	ngOnInit() {}

	openIframeFormModal( form_data ) {
		const modalRef = this.modalService.open(
			IframFormModalComponent,
			{
          		backdrop  : 'static',
   				keyboard  : false,
			}
		);
		modalRef.componentInstance.form_data = form_data;
	}

}